import React, { cloneElement } from 'react';
import { useSelector } from 'react-redux';
import { ButtonToolbar, Modal } from 'reactstrap';

const ModalLayout = (
  {
    modal,
    toggle,
    title,
    subTitle,
    btns,
    children,
    hideCloseButton = false,
    backdrop = true,
    className = '',
    style = {},
  },
  ref
) => {
  // ** redux
  const theme = useSelector((state) => state?.theme?.className);
  return (
    <Modal
      modalClassName={`ltr-support ${className}`}
      className={`${theme === 'theme-dark' ? 'theme-dark' : 'theme-light'}`}
      style={style}
      isOpen={modal}
      toggle={toggle}
      backdrop={backdrop ? 'static' : true}
    >
      <div className="modal__header">
        {!hideCloseButton && (
          <button
            className="lnr lnr-cross modal__close-btn text-danger"
            aria-label="modal__close-btn"
            type="button"
            onClick={toggle}
          />
        )}
        {!!title && (
          <h4 className={`text-modal  modal__title ${subTitle ? 'mb-1' : ''}`}>
            {title}
          </h4>
        )}
        {!!subTitle && <h5 className="subhead">{subTitle}</h5>}
      </div>
      <div className="modal__body">
        {cloneElement(<>{children}</>, { parentRef: ref })}
      </div>
      <ButtonToolbar className="modal__footer justify-content-end mt-3">
        {btns}
      </ButtonToolbar>
    </Modal>
  );
};

export default ModalLayout;
